// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   FormFieldSet,
//   Modal,
//   useFormHandler,
// } from "../../../../../../../components";

// const PayTypeModal = ({ open, onClose,rowData,handleChangeMain }) => {
//   const [showSecondField, setShowSecondField] = useState(false);
// console.log('rowData',rowData);
//   const { formData, errors, handleChange,validateAllFields } = useFormHandler({
//     purchaseOrder1: "",
//     purchaseOrder2: "",
//     purchaseOrder3: "",
//   },{
//       purchaseOrder1: { type: "text", required: true, number:true },
//       purchaseOrder2: { type:"text",
//           // required: true,
//           number:true },
//       purchaseOrder3: { type: "text", required: true, number:true },
//   });

//   const handleCancel = () => {
//     setShowSecondField(false);
//     onClose();
//   };

//   const handleAddField = () => {
//     if (!showSecondField) setShowSecondField(true);
//   };
// const handleSet = () => {
//   const isValid = validateAllFields();

//   if (isValid) {
//     if (handleChangeMain) {
//       // Extract values from formData with default fallback values
//       const billRate = formData?.purchaseOrder3 || 0;
//       const percent = formData?.purchaseOrder1 || 0;
//       const subPercent = formData?.purchaseOrder2 || 0;

//       // Check if both percent and subPercent are valid before doing the calculation
//       let deducted = (billRate * (percent + subPercent)) / 100;
//       let remaining = billRate - deducted;

//       // Call handleChangeMain to update values
//       handleChangeMain("billRate", billRate);
//       handleChangeMain("payRateAndHr", remaining);
//       handleChangeMain("percent", percent);
//       handleChangeMain("subPercent", subPercent);

//       // Close the modal or trigger the onClose action
//       onClose();
//     }
//   }
// }
// const handlePurchaseOrder2=()=>{
// setShowSecondField(false);
// handleChange("purchaseOrder2", '')
// }
// //payRateAndHr
// useEffect(()=>{
// if(rowData?.billRate){
// handleChange("purchaseOrder3", rowData?.billRate)
// }
// },[rowData?.billRate])
//   return (
//     <Modal
//       isOpen={open}
//       onClose={onClose}
//       title="ADD PERCENTAGE"
//       width="max-w-4xl"
//     >
//       <div className="grid grid-cols-2 gap-x-4 gap-y-6 mr-10 ml-10">
//         <div className="col-span-1">
//           <div className="flex items-end gap-2">
//             <div className="flex-1">
//               <FormFieldSet
//                 type="text"
//                 title="Employee Percentage"
//                 placeholder="Enter value"
//                 value={formData.purchaseOrder1}
//                 onChange={(value) => handleChange("purchaseOrder1", value)}
//                 error={errors.purchaseOrder1}
//               />
//             </div>
//             <Button
//               type="icon"
//               icon="add"
//               size="xs-sm"
//               variant="contained"
//               color="black"
//               onClick={handleAddField}
//               className="mb-2"
//             />
//           </div>
//         </div>
//         <div className="col-span-1 ">
//           {showSecondField ? (
//             <div className="flex items-end gap-2">
//               <div className="flex-1">
//                 <FormFieldSet
//                   type="text"
//                   title="Employee Percentage"
//                   placeholder="Enter value"
//                   value={formData.purchaseOrder2}
//                   onChange={(value) => handleChange("purchaseOrder2", value)}
//                   error={errors.purchaseOrder2}
//                 />
//               </div>
//               <Button
//                 type="icon"
//                 icon="remove"
//                 size="xs-sm"
//                 variant="contained"
//                 color="danger"
//                 onClick={() =>handlePurchaseOrder2() }
//                 className="mb-2"
//               />
//             </div>
//           ) : (
//             <div className="h-full" />
//           )}
//         </div>
//         <div className="col-span-1">
//           <div className="flex items-end gap-2">
//             <div className="flex-1">
//               <FormFieldSet
//                 type="text"
//                 title="Bill Rate"
//                 placeholder="Enter value"
//                 value={formData.purchaseOrder3}
//                 onChange={(value) =>handleChange("purchaseOrder3", value)}
//                 error={errors.purchaseOrder3}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="flex gap-3 justify-center my-6">
//         <Button title="Cancel" variant="outlined" onClick={handleCancel} />
//         <Button
//           title="set"
//           onClick={() => {
//             handleSet();
//           }}
//         />
//       </div>
//     </Modal>
//   );
// };

// export default PayTypeModal;

import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  InfoTimeCardAdv,
  Modal,
  useFormHandler,
} from "../../../../../../../components";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../../../../../../utils/stringUtils";

const PayTypeModal = ({
  open,
  onClose,
  rowData,
  handleChangeMain,
  getProfit,
}) => {
  const { loading, error, employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const [payRateToDisplay, setPayRateToDisplay] = useState({
    payRate: 0,
    bonusPayRate: 0,
    bonusPayRateExists: false,
  });
  const [showSecondField, setShowSecondField] = useState(false);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      employeePercentage: "",
      employeePercentage2: "",
      effectiveBillRate: "",
    },
    {
      employeePercentage: { type: "text", required: true, number: true },
      employeePercentage2: {
        type: "text",
        // required: true,
        number: true,
      },
      effectiveBillRate: { type: "text", required: true, number: true },
    },
  );

  const handleCancel = () => {
    handleChange("employeePercentage", "");
    handleChange("employeePercentage2", "");
    handleChangeMain("percent", "");
    handleChangeMain("subPercent", "");
    const billRate = Number(rowData?.billRate).toFixed(0) || 0;
    const referralCharges = Number(rowData?.referralCharges) || 0;
    const vmsCharges = Number(rowData?.vmsCharges).toFixed(2) || 0;
    let afterDeduction = Number(billRate).toFixed(2);
    if (parseInt(vmsCharges) > 0) {
      afterDeduction =
        Number(billRate).toFixed(0) * (1 - Number(vmsCharges).toFixed(2) / 100);
    }
    handleChangeMain(
      "payRateAndHr",
      `${toFloat(afterDeduction - referralCharges)}`,
    );
    setShowSecondField(false);
    onClose();
  };

  const handleAddField = () => {
    if (!showSecondField) setShowSecondField(true);
  };
  const handleSet = () => {
    const isValid = validateAllFields();

    if (isValid) {
      if (handleChangeMain) {
        // Extract values from formData with default fallback values
        const billRate = Number(formData?.effectiveBillRate).toFixed(2) || 0;
        const percent = Number(formData?.employeePercentage).toFixed(2) || 0;
        const subPercent =
          Number(formData?.employeePercentage2).toFixed(2) || 0;
        // Check if both percent and subPercent are valid before doing the calculation
        let deducted =
          Number(billRate).toFixed(2) * (Number(percent).toFixed(2) / 100);
        if (Number(subPercent).toFixed(2) > 0) {
          deducted =
            Number(deducted).toFixed(2) * (Number(subPercent).toFixed(2) / 100);
        }
        //after sending profil to calculate split for the C2C employees - scenario
        const payRate = Number(deducted).toFixed(2);
        getProfit(Number(billRate - payRate).toFixed(2));
        // Call handleChangeMain to update values
        handleChangeMain("payRateAndHr", `${toFloat(deducted)}`);
        handleChangeMain("percent", `${percent}`);
        handleChangeMain("subPercent", `${subPercent}`);
        // Close the modal or trigger the onClose action
        onClose();
      }
    }
  };
  const handlePurchaseOrder2 = () => {
    setShowSecondField(false);
    handleChange("employeePercentage2", "");
  };
  //payRateAndHr
  //   useEffect(() => {
  //     if (rowData?.billRate) {
  //       const billRate = rowData?.billRate || 0;
  //       const vmsCharges = rowData?.vmsCharges || 0;
  //       let afterDeduction =billRate
  //       if(parseInt(vmsCharges)>0){
  //       afterDeduction=parseInt(billRate) * (1 - parseInt(vmsCharges) / 100);
  //       }
  //     handleChange("effectiveBillRate", String(afterDeduction));
  // handleChange("employeePercentage", String(rowData?.percent ?? ""));
  // handleChange("employeePercentage2", String(rowData?.subPercent ?? ""));
  //     }
  //   }, [rowData?.billRate, rowData?.vmsCharges]);

  //working one
  //   useEffect(() => {
  //   if (rowData?.billRate) {
  //     const billRate = rowData?.billRate || 0;
  //     const vmsCharges = rowData?.vmsCharges || 0;
  //     const referralCharges = Number(rowData?.referralCharges) || 0;
  //     let afterDeduction = billRate;
  //     if (parseInt(vmsCharges) > 0) {
  //       afterDeduction = parseInt(billRate) * (1 - parseInt(vmsCharges) / 100);
  //     }
  //     handleChange("effectiveBillRate", String(afterDeduction - referralCharges));
  //     // handleChange("effectiveBillRate", String(calculateEffectiveBillRate()));
  //     handleChange("employeePercentage", String(rowData?.percent ?? ""));
  //     handleChange("employeePercentage2", String(rowData?.subPercent ?? ""));
  //   }
  // }, [rowData?.billRate, rowData?.vmsCharges, rowData?.referralCharges]);
  const toFloat = (val) => Math.round(Number(val) * 100) / 100;

  //testing 1
  useEffect(() => {
    if (rowData?.billRate) {
      const billRate = toFloat(rowData?.billRate) || 0;
      const vmsCharges = toFloat(rowData?.vmsCharges) || 0;
      // const referralCharges = Number(rowData?.referralCharges) || 0;
      // const referralCharges = parseFloat(value) || 0;

      // console.log(
      //   "referralCharges",
      //   referralCharges,
      //   "rowData?.referralArray",
      //   rowData?.referralArray
      // );
      let afterDeduction = billRate;
      if (toFloat(vmsCharges) > 0) {
        afterDeduction = toFloat(billRate) * (1 - toFloat(vmsCharges) / 100);
      }
      const referralCharges = rowData?.referralArray?.reduce((total, item) => {
        const adjustedBillRate = toFloat(afterDeduction);
        const charge = toFloat(
          item.referralChargesType === 2
            ? (adjustedBillRate / 100) * item.referralCharges
            : item.referralCharges,
        );
        return total + (isNaN(charge) ? 0 : charge);
      }, 0);
      const c2cTypeToAllow = [2, 3];
      if (
        !c2cTypeToAllow.includes(
          currentEmployee?.employeeDetails?.employmentType,
        )
      ) {
        handleChange(
          "effectiveBillRate",
          String(Number(afterDeduction - referralCharges)?.toFixed(2)),
        );
      } else {
        handleChange(
          "effectiveBillRate",
          String(Number(afterDeduction)?.toFixed(2)),
        );
      }
      // handleChange("effectiveBillRate", String(calculateEffectiveBillRate()));
      handleChange("employeePercentage", String(rowData?.percent ?? ""));
      handleChange("employeePercentage2", String(rowData?.subPercent ?? ""));
    }
    // }, [rowData?.billRate, rowData?.vmsCharges, rowData?.referralArray]);
  }, [
    rowData?.billRate,
    rowData?.vmsCharges,
    rowData?.referralArray?.map((item) => item.referralCharges).join(),
  ]);

  useEffect(() => {
    const updateRateOnChanges = () => {
      const billRate = Number(formData?.effectiveBillRate).toFixed(2) || 0;
      const percent = Number(formData?.employeePercentage).toFixed(2) || 0;
      const subPercent = Number(formData?.employeePercentage2).toFixed(2) || 0;
      // Check if both percent and subPercent are valid before doing the calculation
      let deducted =
        Number(billRate).toFixed(2) * (Number(percent).toFixed(2) / 100);
      let deductedWithoutSubPercent =
        Number(billRate).toFixed(2) * (Number(percent).toFixed(2) / 100);
      if (Number(subPercent).toFixed(2) > 0) {
        deducted =
          Number(deducted).toFixed(2) * (Number(subPercent).toFixed(2) / 100);
      }
      //after sending profil to calculate split for the C2C employees - scenario
      const payRate = Number(deducted).toFixed(2);
      getProfit(Number(billRate - payRate).toFixed(2));
      // Call handleChangeMain to update values
      setPayRateToDisplay({
        payRate: `${toFloat(deductedWithoutSubPercent)}`,
        bonusPayRate: `${toFloat(deducted)}`,
        bonusPayRateExists: subPercent > 0,
      });
    };
    updateRateOnChanges();
  }, [
    formData.employeePercentage,
    formData.employeePercentage2,
    formData.effectiveBillRate,
  ]);

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="ADD PERCENTAGE"
      width="max-w-5xl"
    >
      <>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(200px,200px))] gap-x-4 gap-y-6 mx-10 mb-4">
          {Number(payRateToDisplay.payRate) > 0 && (
            <InfoTimeCardAdv
              size="sm"
              title="Pay Rate"
              variant="titleContained"
              value={
                Number(payRateToDisplay.payRate)
                  ? formatCurrency(Number(payRateToDisplay.payRate))
                  : "-"
              }
              color="primary"
            />
          )}

          {payRateToDisplay?.bonusPayRateExists && (
            <InfoTimeCardAdv
              size="sm"
              title="Bonus Pay Rate"
              variant="titleContained"
              value={
                Number(payRateToDisplay.bonusPayRate)
                  ? formatCurrency(Number(payRateToDisplay.bonusPayRate))
                  : "-"
              }
              color="primary"
            />
          )}
        </div>

        <div className="grid grid-cols-2 gap-x-4 gap-y-6 mr-10 ml-10">
          <div className="col-span-1">
            <div className="flex items-end">
              <div className="flex flex-1">
                <div className="flex-1">
                  <FormFieldSet
                    type="text"
                    title="Employee Percentage"
                    placeholder="Enter Value"
                    value={formData.employeePercentage}
                    onChange={(value) => {
                      if (Number(value) > 100) return;
                      handleChange("employeePercentage", value);
                    }}
                    error={errors.employeePercentage}
                    disabled={showSecondField}
                  />
                </div>
                {/* <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm">
                  %
                </div>*/}
                <div
                  className="bg-primary text-white mt-[18px]
                              w-8 h-[38px]
                              flex items-center justify-center
                              rounded-tr-sm rounded-br-sm"
                >
                  %
                </div>
                {Number(formData.employeePercentage) > 0 && (
                  <div className="ml-2 flex justify-center items-end">
                    <Button
                      type="icon"
                      icon="add"
                      size="xs-sm"
                      variant="contained"
                      color="black"
                      onClick={handleAddField}
                      className="mb-2"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-span-1 ">
            {showSecondField ? (
              <div className="flex items-end">
                <div className="flex-1">
                  <FormFieldSet
                    type="text"
                    title="Employee Percentage"
                    placeholder="Enter Value"
                    value={formData.employeePercentage2}
                    onChange={(value) =>
                      handleChange("employeePercentage2", value)
                    }
                    error={errors.employeePercentage2}
                  />
                </div>
                <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm">
                  %
                </div>
                <div className="ml-2">
                  <Button
                    type="icon"
                    icon="remove"
                    size="xs-sm"
                    variant="contained"
                    color="danger"
                    onClick={() => handlePurchaseOrder2()}
                    className="mb-2"
                  />
                </div>
              </div>
            ) : (
              <div className="h-full" />
            )}
          </div>
          <div className="col-span-1">
            <div className="flex items-end gap-2">
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  title="Effective Bill Rate"
                  placeholder="Enter Value"
                  value={formData.effectiveBillRate}
                  onChange={(value) => handleChange("effectiveBillRate", value)}
                  error={errors.effectiveBillRate}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-3 justify-center my-6">
          <Button title="Cancel" variant="outlined" onClick={handleCancel} />
          <Button
            title="Set"
            onClick={() => {
              handleSet();
            }}
          />
        </div>
      </>
    </Modal>
  );
};

export default PayTypeModal;
